export default class ThumbnailBox {
  constructor(boxNode) {
    this.boxNode = boxNode;

    if (this.boxNode) {
      this.targetNode = this.boxNode.querySelector('.js-thumbnails-box-target');
      this.controlsNodes = Array.from(this.boxNode.querySelectorAll('.js-thumbnails-box-control'));

      this.initEvents();
    }
  }

  initEvents() {
    this.controlsNodes.forEach(control => {
      control.addEventListener('click', (el) => {
        const imgNode = el.target.querySelector('img');

        if(imgNode) {
          const tmp = this.targetNode.src;
          this.targetNode.src = imgNode.src;
          imgNode.src = tmp;
        }
      }, false);
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/thumbnails.js